module.exports = __webpack_public_path__ + "img/collection-weddingRingsWaveDesign@2x.4bb8f66.webp";